import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useRubricCache } from './cache'
import { type RecordingRubricRemoveInput, toResponseError, type RecordingRubricRemoveSuccess } from '@terros/common'

export function useRemoveRubric(): RemoveHookResponse<RecordingRubricRemoveInput> {
  const mutation = useTantalimMutation<RecordingRubricRemoveInput, RecordingRubricRemoveSuccess>({
    url: '/recording/rubric/remove',
  })
  const cache = useRubricCache()

  async function remove(input: RecordingRubricRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearItem(input.rubricId)
      cache.clearList()
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
